export const EMAIL_LOG_STATUSES = ['sending', 'accepted', 'failed', 'unknown'] as const;
export type EmailLogStatus = (typeof EMAIL_LOG_STATUSES)[number];
export const EMAIL_LOG_TRIGGERS = ['scheduled', 'operator', 'mcp', 'public', 'workflow', 'system'] as const;
export type EmailLogTrigger = (typeof EMAIL_LOG_TRIGGERS)[number];
export type EmailLogTransport = 'ses' | 'mailpit';
export type EmailLogRecipientKind = 'actual' | 'intended';

export interface EmailLogRelatedEntity {
  type: string;
  id: string;
}

export interface EmailLogFilters {
  from?: string;
  to?: string;
  recipient?: string;
  recipientExact?: boolean;
  domain?: string;
  recipientKind?: EmailLogRecipientKind;
  status?: EmailLogStatus;
  purpose?: string;
  trigger?: EmailLogTrigger;
  actorId?: string;
  transport?: EmailLogTransport;
  subject?: string;
  relatedEntityId?: string;
  page?: number;
  pageSize?: number;
}

export interface EmailLogRecipient {
  address: string;
  kind: EmailLogRecipientKind;
  status: EmailLogStatus;
}

export interface EmailLogRow {
  id: string;
  createdAt: string;
  completedAt: string | null;
  status: EmailLogStatus;
  purpose: string;
  trigger: EmailLogTrigger;
  actorId: string | null;
  transport: EmailLogTransport;
  subject: string;
  recipients: EmailLogRecipient[];
  relatedEntities: EmailLogRelatedEntity[];
  deliveryKey: string | null;
  outcomeCode: string | null;
}

export interface EmailLogDetail extends EmailLogRow {
  updatedAt: string;
  fromAddress: string;
  fromName: string;
  replyTo: string[];
  textBody: string;
  htmlBody: string | null;
  messageId: string | null;
  errorMessage: string | null;
  redacted: boolean;
}

export interface EmailLogPage<T> {
  data: T[];
  total: number;
  page: number;
  pageSize: number;
  earliestRecordAt: string | null;
}

export interface EmailLogRecipientSummary {
  address: string;
  attempts: number;
  accepted: number;
  failed: number;
  unknown: number;
  sending: number;
  lastActivityAt: string;
  accepted24h: number;
  accepted7d: number;
  accepted30d: number;
}
